var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFF4ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6516_291677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4895 17.3668H14.685C15.4376 17.3668 16.0534 17.9826 16.0534 18.7352V25.5772C16.0534 26.3298 15.4376 26.9456 14.685 26.9456H14.4895C13.7369 26.9456 13.1211 26.3298 13.1211 25.5772V18.7352C13.1211 17.9826 13.7369 17.3668 14.4895 17.3668ZM19.9631 13.2616C20.7157 13.2616 21.3315 13.8774 21.3315 14.63V25.5772C21.3315 26.3298 20.7157 26.9456 19.9631 26.9456C19.2105 26.9456 18.5947 26.3298 18.5947 25.5772V14.63C18.5947 13.8774 19.2105 13.2616 19.9631 13.2616ZM25.4367 21.081C26.1893 21.081 26.8051 21.6968 26.8051 22.4494V25.5772C26.8051 26.3298 26.1893 26.9456 25.4367 26.9456C24.6841 26.9456 24.0683 26.3298 24.0683 25.5772V22.4494C24.0683 21.6968 24.6841 21.081 25.4367 21.081Z",
    fill: "#F1935C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6516_291677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4583,
    height: 23.4583,
    fill: "white",
    transform: "translate(8.23438 8.37439)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarOrange);
export default __webpack_public_path__ + "static/media/Bar_Orange.ea3377bf1f5b5b11af43e5a03e9b5840.svg";
export { ForwardRef as ReactComponent };